"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascadeOutlined = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.CascadeOutlined = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H5.25C5.94036 14.5 6.5 13.9404 6.5 13.25V10.5269C7.08419 11.2278 7.75563 11.8551 8.5 12.3923V13.25C8.5 13.9404 9.05964 14.5 9.75 14.5H13.25C13.9404 14.5 14.5 13.9404 14.5 13.25V9.75C14.5 9.05964 13.9404 8.5 13.25 8.5H9.75C9.05964 8.5 8.5 9.05964 8.5 9.75V10.4584C7.7348 9.75195 7.08977 8.92174 6.59338 8C7.08977 7.07826 7.7348 6.24805 8.5 5.54164V6.25C8.5 6.94036 9.05964 7.5 9.75 7.5H13.25C13.9404 7.5 14.5 6.94036 14.5 6.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H9.75C9.05964 1.5 8.5 2.05964 8.5 2.75V3.60769C7.75563 4.14495 7.08419 4.77216 6.5 5.47311V2.75C6.5 2.05964 5.94036 1.5 5.25 1.5H2.75C2.05964 1.5 1.5 2.05964 1.5 2.75ZM5 7.98375L4.99984 7.99999L5 8.01625V13H3V3H5V7.98375ZM10 3H13V6H10V3ZM10 13V10H13V13H10Z", fill: colors[0] }));
    },
    name: 'cascade_outlined',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H5.25C5.94036 14.5 6.5 13.9404 6.5 13.25V10.5269C7.08419 11.2278 7.75563 11.8551 8.5 12.3923V13.25C8.5 13.9404 9.05964 14.5 9.75 14.5H13.25C13.9404 14.5 14.5 13.9404 14.5 13.25V9.75C14.5 9.05964 13.9404 8.5 13.25 8.5H9.75C9.05964 8.5 8.5 9.05964 8.5 9.75V10.4584C7.7348 9.75195 7.08977 8.92174 6.59338 8C7.08977 7.07826 7.7348 6.24805 8.5 5.54164V6.25C8.5 6.94036 9.05964 7.5 9.75 7.5H13.25C13.9404 7.5 14.5 6.94036 14.5 6.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H9.75C9.05964 1.5 8.5 2.05964 8.5 2.75V3.60769C7.75563 4.14495 7.08419 4.77216 6.5 5.47311V2.75C6.5 2.05964 5.94036 1.5 5.25 1.5H2.75C2.05964 1.5 1.5 2.05964 1.5 2.75ZM5 7.98375L4.99984 7.99999L5 8.01625V13H3V3H5V7.98375ZM10 3H13V6H10V3ZM10 13V10H13V13H10Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
